/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc Webフォームボタンメッセージ
 *
 * @author duan
 * @copyright Copyright 2021 TechMatrix Corporation, Inc. All rights reserved.
 */
<script>
import FcQuestionMessage from './FcQuestionMessage'
import FcMessageUtil from '@/utils/FcMessageUtil'

export default {
  mixins: [FcQuestionMessage],
  name: 'FcWebFormButtonMessage',
  computed: {
    /**
     * messageClass のオーバーライド
     */
    messageClass() {
      return 'fc-web-form-button-message ' + 'fc-text-message ' + FcMessageUtil.messageDistributionClass(this.messageInfo)
    },
    /**
     * answerList のオーバーライド
     */
    answerList() {
      let messageOption = JSON.parse(this.messageInfo.messageOption)
      let answerList = [{
        id: 0,
        label: messageOption.label,
        buttonType: 'primary',
        alwaysEnable: true
      }]
      return answerList
    }
  },
  methods: {

    /**
     * sendAnswerMessage のオーバーライド
     */
    sendAnswerMessage(answerInfo) {
      let messageOption = JSON.parse(this.messageInfo.messageOption)
      let webFormSettingId = messageOption.webFormSettingId || ''
      if (!this.permissionSendAnswerMessage(answerInfo)) {
        return
      }
      this.$emit('openWebForm', webFormSettingId)
    },

    /**
     * getSendMessageAnswerList のオーバーライド
     */
    getSendMessageAnswerList() {
      return []
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/chatWindow/chatMain/message/FcWebFormButtonMessage.vue